import { AgencyId, UserId } from "@inrev/common";
import { useMutation } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";

export const useAdminResendAgentInvitation = () => {
	const { post } = useRequest();

	const mutation = useMutation({
		mutationKey: ["adminResendAgentInvitation"],
		mutationFn: async ({ agencyId, agentId }: { agencyId: AgencyId; agentId: UserId }) =>
			await post(
				`/v2/admin/agencies/${agencyId}/agents/${agentId}/invite/resend`,
				undefined,
				"none",
			),
	});

	return {
		adminResendAgentInvitation: mutation.mutate,
		adminResendAgentInvitationIsLoading: mutation.isPending,
		adminResendAgentInvitationError: mutation.error,
	};
};
